/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the Professional Portal Login page
    // Google map constructor
    function new_map( $el ) {

      // var
      const $markers = $el.find('.marker');


      // vars
      const args = {
        zoom    : 16,
        center    : new google.maps.LatLng(0, 0),
        mapTypeId : google.maps.MapTypeId.ROADMAP
      };


      // create map
      const map = new google.maps.Map( $el[0], args);


      // add a markers reference
      map.markers = [];


      // add markers
      $markers.each(function(){

          add_marker( $(this), map );

      });


      // center map
      center_map( map );


      // return
      return map;

    }

    /*
    *  add_marker
    *
    *  This function will add a marker to the selected Google Map
    *
    *  @type  function
    *  @date  8/11/2013
    *  @since 4.3.0
    *
    *  @param $marker (jQuery element)
    *  @param map (Google Map object)
    *  @return  n/a
    */

    function add_marker( $marker, map ) {

      // var
      const latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

      // create marker
      const marker = new google.maps.Marker({
        position  : latlng,
        map
      });

      // add to array
      map.markers.push( marker );

      // if marker contains HTML, add it to an infoWindow
      if( $marker.html() )
      {
        // create info window
        const infowindow = new google.maps.InfoWindow({
          content   : $marker.html()
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', () => {

          infowindow.open( map, marker );

        });
      }

    }

    // Center the map
    function center_map( map ) {

      // vars
      const bounds = new google.maps.LatLngBounds();

      // loop through all markers and create bounds
      $.each( map.markers, (i, marker) => {

        const latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

      });

      // only 1 marker?
      if( map.markers.length == 1 )
      {
        // set center of map
          map.setCenter( bounds.getCenter() );
          map.setZoom( 16 );
      }
      else
      {
        // fit to bounds
        map.fitBounds( bounds );
      }

    }

    $('body').append(`<script src="https://maps.googleapis.com/maps/api/js?key=${professional_portal_login.google_maps_api_key}" async defer></script>`);



    // global var
    let map = null;

    // Load map when document is ready
    $(window).load(() => {



      $('.modal').on('shown.bs.modal', function (e) {

          if($(this).find('.marker').length !== 0){

            map = new_map( $(this).find('.acf-map') );

          }

          if(map != null){
            // popup is shown and map is not visible
            google.maps.event.trigger(map, 'resize');
          }

      })


    });
  },
  finalize() {
    // JavaScript to be fired on the Professional Portal Login page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/professionalPortalLogin.js